module.exports = __webpack_public_path__ + "static/img/weibo.fd37d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qxr/weibo.png
// module id = Lhc2
// module chunks = 51